import type { SVGProps } from "react";
export interface TicketAirlineIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TicketAirlineIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TicketAirlineIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 8c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v8c0 1.035.84 1.875 1.875 1.875h14c1.035 0 1.875-.84 1.875-1.876v-.432a3.62 3.62 0 0 1-3-3.566 3.624 3.624 0 0 1 3-3.569zm2.25 1.5c0 .621-.504 1.125-1.125 1.125h-.5a1.376 1.376 0 0 0 0 2.75h.5c.62 0 1.124.503 1.125 1.124V16A4.125 4.125 0 0 1 19 20.125H5a4.125 4.125 0 0 1-4.125-4.126V8A4.125 4.125 0 0 1 5 3.875h14A4.125 4.125 0 0 1 23.125 8z"
      />
      <path
        fill={color}
        d="M16.141 14.632a1.375 1.375 0 1 1-1.509 1.509L14.625 16l.007-.14A1.376 1.376 0 0 1 16 14.623l.141.008Zm-8.04-7.257.149.01c.346.047.654.251.83.56l1.376 2.43h.593c.486 0 .982.079 1.388.214.196.066.43.163.638.312.152.108.6.464.6 1.098 0 .636-.448.992-.6 1.1a2.4 2.4 0 0 1-.638.313 4.5 4.5 0 0 1-1.388.213h-.594l-1.376 2.43c-.2.352-.574.57-.978.57h-.052a1.126 1.126 0 0 1-1.066-1.48l.505-1.52h-.756l-.616.65a1.13 1.13 0 0 1-.816.35h-.05a1.126 1.126 0 0 1-.993-1.654l.518-.972-.518-.97a1.126 1.126 0 0 1 .993-1.654h.05l.114.005c.266.027.516.149.702.345l.616.65h.756l-.505-1.519a1.126 1.126 0 0 1 1.066-1.481zm8.04 3.258a1.374 1.374 0 1 1-1.509 1.507l-.007-.14.007-.141A1.375 1.375 0 0 1 16 10.626zm0-4a1.375 1.375 0 1 1-1.509 1.508l-.007-.14.007-.141A1.375 1.375 0 0 1 16 6.625l.141.007Z"
      />
    </svg>
  );
}
